import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SlateDatePicker from 'components/Shared/SlateDatePicker/SlateDatePicker';

var DateTimePicker = function(props) {
  return (
    <SlateDatePicker
      value={props.value}
      onChange={props.onChange}
      showTime={props.showTime}
      t={props.t}
      disabled={props.disabled}
    />
  );
};

DateTimePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  showTime: PropTypes.bool,
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default withTranslation()(DateTimePicker);
